import {useEffect, useState} from 'react';
import {PwModal} from './modal/PwModal';
import {useUser} from '../../../util/userContext/UserContext';
import {useModal} from "../../../hooks";
import { SearchSystemUserInner } from '../../../components/common/modal/inner/SearchSystemUserInner';
import { updateUserCrmIdApi } from '../../../api/account/AccountApi';
import { useMutation } from '@tanstack/react-query';

export const MyPage = () => {
    const {handleModal} = useModal();
    const {user} = useUser();

    const [show, setShow] = useState(false);

    const [isSuccess, setIsSuccess] = useState(false);

    const [newCrmId, setNewCrmId] = useState("");

    const handleClose = () => {
        setShow(false);
    };

    useEffect(() => {
        if (isSuccess) {
            handleModal({isOpen: true, contents: "비밀번호가 변경되었습니다.", type: "alert"})
            setIsSuccess(!isSuccess)
        }
    }, [isSuccess])

    const updateUserCrmIdApiMutate = useMutation({
        mutationFn: (crmId:string)=> updateUserCrmIdApi({userId : user?.userId, crmId : crmId}),
        onSuccess: (res) => {
            if(res.data.code === "0000"){
                handleModal({isOpen: true, contents: "CRM ID가 연동되었습니다.", type: "alert"})
                if(user){
                    user.crmId = newCrmId;
                }
                return;
            }else{
                handleModal({isOpen: true, contents: "CRM ID연동에 실패했습니다.", type: "alert"})
            }
        },
        onError: (error) => {
            handleModal({isOpen: true, contents: "CRM ID연동에 실패했습니다.", type: "alert"})
            return;
        },
    });

    // 내부수정: 컬럼 위치 변경
    return (
        <div className="content_wrap">
            <div className="fiter_top">
                <h3 className="filter_heading">마이페이지</h3>
                <div className="filter_toolbar">
                    {user?.dutyGroupTypeName === "내부" &&
                    <button className="btn btn-info px-16px"
                        onClick={() => {
                                handleModal({
                                    isOpen: true,
                                    contents: (
                                        <SearchSystemUserInner
                                            confirmCallback={(item:any) => {
                                                console.log(item)
                                                updateUserCrmIdApiMutate.mutate(item.systemuserid)
                                                setNewCrmId(item.systemuserid)
                                            }}
                                            modalDepth={1}
                                        />
                                    ),
                                    type: "",
                                    title: "사용자 조회",
                                    modalSize: "xl",
                                });
                            }}
                        >
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>CRM 계정{user?.crmId === "" ? " 연동" : " 변경"}
                    </button>}
                    <button className="btn btn-secondary px-16px"
                            onClick={() => {
                                setShow((prevShow) => {
                                    return !prevShow;
                                });
                            }}>
                        <img className="me-7px" src={process.env.PUBLIC_URL + "/assets/images/icon_pencil.png"} alt=""/>
                        비밀번호 수정
                    </button>
                </div>
            </div>
            {show && <PwModal isShow={show} onClose={handleClose} userId={Number(user?.userId)}
                              setIsSuccess={setIsSuccess}/>}
            <div className="mypage_container">
                <div className="left">
                    <div className="profile_pic">
                        {/* <div className="icon_camera"></div> */}
                    </div>
                    <div className="line1" style={{marginBottom : "5px"}}><span>{user?.userName}</span> {user?.title}</div>
                    <div className="line2" style={{fontSize:"10px", textAlign:"center", color:"#4C4C4C"}}>CRM ID : {user?.crmId}</div>
                    <div className="line2"><span>{user?.companyName}</span></div>
                    <div className="line2"><span>{user?.departmentName}</span><span>{user?.teamName}</span></div>
                    <div className="line3"><img className="me-7px"
                                                src={process.env.PUBLIC_URL + "/assets/images/icon_phone_sm.png"}
                                                alt=""/>{user?.phoneNo}</div>
                    <div className="line3"><img className="me-7px"
                                                src={process.env.PUBLIC_URL + "/assets/images/icon_mail_sm.png"}
                                                alt=""/>{user?.coEmail}</div>
                </div>
                <div className="right">
                    <h5 className="subheading mt-0">기본정보</h5>
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                        <tr>
                            <th style={{width: "25%"}}>ID</th>
                            <td style={{width: "25%"}}>{user?.loginId}</td>
                        </tr>
                        <tr>
                            <th style={{width: "25%"}}>이름</th>
                            <td>{user?.userName}</td>
                            <th style={{width: "25%"}}>직함</th>
                            <td style={{width: "25%"}}>{user?.title}</td>
                        </tr>
                        <tr> 
                            <th style={{width: "25%"}}>역할</th>
                            <td>{user?.roleName}</td>
                            <th>생성일시</th>
                            <td>{user?.regAt}</td>
                        </tr>
                        </tbody>
                    </table>

                    <h5 className="subheading">회사정보</h5>
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                        <tr>
                            <th style={{width: "25%"}}>회사명</th>
                            <td style={{width: "25%"}}>{user?.companyName}</td>
                            <th style={{width: "25%"}}>회사 이메일</th>
                            <td>{user?.coEmail}</td>
                        </tr>
                        <tr>
                            <th style={{width: "25%"}}>부서</th>
                            <td>{user?.departmentName}</td>
                            <th style={{width: "25%"}}>팀</th>
                            <td colSpan={3}>{user?.teamName}</td>
                        </tr>
                        <tr>
                            <th style={{width: "25%"}}>근무처 전화</th>
                            <td>{user?.extensionNo}</td>
                            <th style={{width: "25%"}}>휴대폰</th>
                            <td>{user?.phoneNo}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}